import { createRouter, createWebHistory,createWebHashHistory  } from 'vue-router'

const routes = [
  // 重定向
  // {
  //   path: '/news.html',
  //   redirect: 'news'
  // },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home.vue'),
  },
  {
    path: '/login/:id',
    component: () => import('../views/login.vue')
  },
  {
    path: '/email/:id',
    component: () => import('../views/email.vue')
  },
  {
    path: '/retrieve',
    component: () => import('../views/retrieve.vue')
  },
  {
    path: '/activity',
    component: () => import('../views/activity.vue'),
  },
  {
    path: '/shops',
    component: () => import('../views/shops.vue')
  },
  {
    path: '/shops/?id',
    component: () => import('../views/shops.vue')
  },
  {
    path: '/shop/:a/:b/:c.html',
    component: () => import('../views/shops.vue')
  },
  {
    path: '/news/:id.html',
    component: () => import('../views/news.vue'),
  },
  {
    path: '/news.html',
    component: () => import('../views/news.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),//history
  // history: createWebHistory(process.env.BASE_URL),//hash
  routes,
})
/** 全局前置路由守卫 */
router.beforeEach((to, from, next) => {
  // console.log('to', to);
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});


// let registerRouteFresh = true
// router.beforeEach((to, from, next) => {
// 获取vuex中存储的权限菜单信息
// const sidebarRouteData = vuex.state.permission.sidebarRoute
// 将菜单信息转换为路由对象
// const routeArr = generateRoutes(sidebarRouteData)
// // 循环添加路由
// routeArr.forEach(v => {
//   // 依次添加路由对象，第一个参数为父级命名路由名称
//   router.addRoute('Article', v)
// })
// // 更改路由刷新标识
// registerRouteFresh = false
// // 添加完路由再次触发一次路由跳转且设置替换
// next({ ...to, replace: true })
// })

export default router
